import React, { useEffect, useState } from "react";
import { getFirestore } from "../../config/firebase";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";

const WhatsAppFlotante = () => {
  const [numerosWhatsapp, setNumerosWhatsapp] = useState([]);
  const [mostrarWhatsapp, setMostrarWhatsapp] = useState(true);

  const [whatsappIndividual, setWhatsappIndividual] = useState(null);

  // useEffect(() => {
  //   const db = getFirestore();
  //   const vehicles = db.collection("fiat-informacion");

  //   vehicles.get().then((querySnapshot) => {
  //     const datosCompletos = querySnapshot.docs.map((doc) => ({
  //       ...doc.data(),
  //       id: doc.id,
  //     }));
  //     setWhatsappIndividual(datosCompletos[1].url);
  //     setNumerosWhatsapp(datosCompletos[1].numeros);
  //     setMostrarWhatsapp(datosCompletos[1].mostrar);
  //   });
  // }, []);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      await updateData(values);
      setOpen(false);
      // Construir la URL con origen CONSULTA WEB
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("utm_source", "CONSULTA WEB");
      const urlWithUtm = currentUrl.toString();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.location.href = `https://api.whatsapp.com/send?phone=5493513527817&text=${encodedMessage}`;
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  if (!mostrarWhatsapp) {
    return null;
  }

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;

